import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { Link } from 'react-router-dom';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Chart, destroy } from 'chart.js/auto';
import {baseUrl, baseimgUrl, userLocation, ipAddress, userName, formatDateTime} from '../Univ.js'

function OpDashboard(props){
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [opData, setopData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const chartRef = useRef(null);
  const handleStartDateChange = (date) => {
  const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
  setStartDate(localDate);
};
const handleEndDateChange = (date) => {
  const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
  setEndDate(localDate);
};

  useEffect(() => {
      fetchData();

  }, [startDate, endDate]);


  function fetchData() {
  setIsLoading(true);
  const startDateString = startDate ? startDate.toISOString().substring(0, 10) : '';
  const endDateString = endDate ? endDate.toISOString().substring(0, 10) : '';
  const url = `${baseUrl}op-appointment-view/?start_date=${startDateString}&end_date=${endDateString}`;
  axios.get(url)
    .then(response => {
      setopData(response.data);
      setIsLoading(false);
    })
    .catch(error => {
      console.log(error);
      setIsLoading(false);
    });
  }
    const rows = opData.map(item => ({
      id: item.id,
      appt_date: item.appt_date,
      cons__consultant: item.cons__consultant,
      appt_id: item.appt_id,
      pat__pat_id: item.pat__pat_id,
      pat__patient: item.pat__patient,
      pat__age: item.pat__age,
      pat__address1: item.pat__address1,
      appt_time: item.appt_time,
      status: item.status,
    }));


  const columns = [
    { field: 'appt_date', headerName: 'Date', width: 100 },
    { field: 'cons__consultant', headerName: 'Consultant', width: 120},
    { field: 'appt_id', headerName: 'Appt Id', width: 120},
    { field: 'pat__pat_id', headerName: 'Patient ID', width: 100},
    { field: 'pat__patient', headerName: 'Patient', width: 170 },
    { field: 'pat__age', headerName: 'Age', width: 70 },
    { field: 'pat__address1', headerName: 'Address', width: 250 },
    { field: 'appt_time', headerName: 'Appt Slot', width: 120 },
    { field: 'status', headerName: 'Status', width: 90,
    renderCell: (params) => {
      const status = params.value;
      return (
        <>
          {status === 1 && (
            <span className="badge bg-primary">Pending</span>
          )}
          {status === 2 && (
            <span className="badge bg-warning">Waiting</span>
          )}
          {status === 3 && (
            <span className="badge bg-success">Completed</span>
          )}
        </>
      );
    },
    },
  ];

    const appointmentCountsByConsultant = {};
    opData.forEach((opview) => {
      const consultant = opview.cons__consultant;
      const appointmentType = opview.type;
      const appointmentStatus = opview.status;

      if (!appointmentCountsByConsultant[consultant]) {
        appointmentCountsByConsultant[consultant] = {
          consultant,
          appointments: 0,
          pending: 0,
          new: 0,
          revisit: 0,
          completed: 0,
          cancel: 0,
        };
      }

      appointmentCountsByConsultant[consultant].appointments++;

      if (appointmentStatus <= 2) {
        appointmentCountsByConsultant[consultant].pending++;
      }
      if (appointmentType === 'new') {
        appointmentCountsByConsultant[consultant].new++;
      }
      if (appointmentType === 'revisit') {
        appointmentCountsByConsultant[consultant].revisit++;
      }
      if (appointmentStatus === 3) {
        appointmentCountsByConsultant[consultant].completed++;
      }
      if (appointmentStatus === 0) {
        appointmentCountsByConsultant[consultant].cancel++;
      }
    });

  useEffect(() => {
  const ctx = chartRef.current.getContext("2d");

  // Clear the canvas
  ctx.clearRect(0, 0, chartRef.current.width, chartRef.current.height);

  const chart = new Chart(ctx, {
    type: "bar",
    data: {
      labels: ["Pending", "New", "Revisit", "Completed", "Cancel"],
      datasets: Object.values(appointmentCountsByConsultant).map((counts) => ({
        label: counts.consultant,
        data: [
          counts.pending,
          counts.new,
          counts.revisit,
          counts.completed,
          counts.cancel,
        ],
        backgroundColor: [
          "rgba(255, 99, 132, 0.5)", // Pending
          "rgba(54, 162, 235, 0.5)", // New
          "rgba(255, 206, 86, 0.5)", // Revisit
          "rgba(75, 192, 192, 0.5)", // Completed
          "rgba(153, 102, 255, 0.5)", // Cancel
        ],
      })),
    },
    // Chart configuration options
  });

  // Cleanup function
  return () => {
    chart.destroy(); // Destroy chart instance on unmount
  };
  }, [appointmentCountsByConsultant]);

  return (
    <section className="container mt-4">
    <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}><i className="fa-solid fa-calendar-days"
        aria-hidden="true" style={{color: 'red'}}></i> OP Dashboard Report</h3>
      <div className="row">
        <div className="col-md-6">
          <div className="form-group">
            <label className="col-sm-3 col-lg-2 control-label">Select Date</label>
            <div className="col-sm-9 col-lg-10 controls">
            <DatePicker
            selected={startDate}
            onChange={handleStartDateChange}
            selectsStart
            startDate={startDate}
            endDate={endDate}
            placeholderText={'Please select From date'}
            dateFormat="dd/MM/yyyy"
         />
         <DatePicker
            selected={endDate}
            onChange={handleEndDateChange}
            selectsEnd
            startDate={startDate}
            endDate={endDate}
            minDate={startDate}
            placeholderText={'Please select To date'}
            dateFormat="dd/MM/yyyy"
         />

            </div>
          </div>
        </div>
      </div>
      <div className="row mt-4">
      <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}>
        <i className="fa-solid fa-list" aria-hidden="true" style={{color: 'red'}}></i>
          View Patient Appointment History</h3>
       <div className="table-responsive">
       <table className="erp-table-modern">
        <thead>
        <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
          <th>Consultant</th>
          <th>Appointments</th>
          <th>Pending</th>
          <th>New</th>
          <th>Revisit</th>
          <th>Completed</th>
          <th>Cancel</th>
        </tr>
      </thead>
      <tbody>
         {Object.values(appointmentCountsByConsultant).map((counts, index) => (
        <tr key={index}>
          <td>{counts.consultant}</td>
          <td>{counts.appointments}</td>
          <td>{counts.pending}</td>
          <td>{counts.new}</td>
          <td>{counts.revisit}</td>
          <td>{counts.completed}</td>
          <td>{counts.cancel}</td>
        </tr>
      ))}
      </tbody>
    </table>
    </div>
    </div>
      {!isLoading && opData.length > 0 ? (
        <div style={{ height: "100%", width: "100%" }}>
          <DataGrid className="mt-4"
            sx={{
              boxShadow: 4,
              border: 4,
              borderColor: 'primary.light',
              '& .MuiDataGrid-cell:hover': {
                color: 'primary.main',
              },
            }}
            rows={rows}
            columns={columns}
            pageSize={10}
            slots={{
              toolbar: GridToolbar,
            }}
            autoHeight
          />
        </div>
      ) : (
        <></>
      )}
      <canvas ref={chartRef}></canvas>
    </section>
  )
}

export default OpDashboard;
